import {
  Route,
  Routes,
  Navigate,
  useParams,
  useNavigate,
  useSearchParams,
} from 'react-router';
import i18n from 'i18next';

import {
  Flex,
  TextBreadcrumbs,
} from 'web-styled';

import {
  Icon,
  Button,
  ContentWrapper,
  NavigationTabs,
} from 'web-components';

import Items from './Items';

const TagPage = () => {
  const { tag } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const { search } = window.location;
  const tabs = ['all', 'exercises', 'workouts', 'programs', 'documents'];
  const getTabs = () => tabs.map(
    name => ({
      name: i18n.t(name),
      to: `/tags/${tag}/${name}/${search}`,
    }),
  );

  return (
    <ContentWrapper
      header={(
        <Flex
          fillSpace
          align="center"
          justify="space-between"
        >
          <Flex align="center" spacing={10}>
            <Button
              appearance="link"
              onClick={() => {
                const back = searchParams.get('back');
                if (back) {
                  navigate(back);
                } else {
                  navigate(-1);
                }
              }}
            >
              <Icon type="fa fa-chevron-left" />
            </Button>
            <TextBreadcrumbs>
              {tag}
            </TextBreadcrumbs>
          </Flex>
          <Flex
            align="center"
            spacing={10}
          >
            <NavigationTabs
              tabs={getTabs()}
            />
          </Flex>
        </Flex>
        )}
    >
      <Flex
        column
        fillSpace
        spacing={10}
      >
        <Routes>
          <Route
            index
            element={<Navigate to="all" />}
          />
          <Route
            path=":tagType"
            Component={Items}
          />
        </Routes>
      </Flex>
    </ContentWrapper>
  );
};

export default TagPage;
